import React from 'react';

const Form = ({
  autoComplete = true,
  children,
  className = '',
  onSubmit = null,
  id = null,
  action = null,
  method = null,
}) => {
  const autoCompleteAttr = autoComplete === false ? 'off' : 'on';

  return (
    <form
      id={id}
      className={className}
      onSubmit={onSubmit instanceof Function ? onSubmit : null}
      action={action}
      method={method}
      autoComplete={autoCompleteAttr}
    >
      {children}
    </form>
  );
};

export default Form;
